import React, { ReactNode } from 'react';

import styles from './listing-page-row-metric-cell.scss';

type MetricSize = 'default' | 'medium' | 'wide' | 'pages' | 'status' | 'statusLarge' | 'statusExtraLarge';

interface ListingPageRowMetricCellProps {
  label: ReactNode;
  value: ReactNode;
  subLabel?: ReactNode;
  size?: MetricSize;
}

const getSizeClass = (size: MetricSize): string => {
  switch (size) {
    case 'medium':
      return styles.metricMedium;
    case 'wide':
      return styles.metricWide;
    case 'pages':
      return styles.metricPages;
    case 'status':
      return styles.metricStatus;
    case 'statusLarge':
      return styles.metricStatusLarge;
    case 'statusExtraLarge':
      return styles.metricStatusExtraLarge;
    default:
      return styles.metric;
  }
};

export const ListingPageRowMetricCell = ({
  label,
  value,
  subLabel,
  size = 'default'
}: ListingPageRowMetricCellProps) => (
  <div className={getSizeClass(size)} role="cell">
    <span className={styles.metricLabel}>{label}</span>
    <span className={styles.metricValue}>{value}</span>
    {subLabel && <span className={styles.metricSubLabel}>{subLabel}</span>}
  </div>
);
